import React, { useEffect, useState } from 'react';
import './ProductValuation.scss';
import DynaDatePicker from '../../../A13/DynaView/DynaDatePicker';
import _axios from '../../../../httpService';
import { prefixUrl } from '../../../../utils/utilsData';
import { toast } from "react-toastify";
import numeric from "../../../../utils/NumericFunction";
import Loader from '../../../Loader';
import UtilsFunctions from '../../../../utils/UtilsFunctions';
import { useNavigate, useLocation } from "react-router-dom";
import Swal from "sweetalert2";
import UploadExcelModal from './UploadExcelModal';
import XLSX from "xlsx";

const ProductValuation = () => {
  /*** تنظیمات تاریخ ***/
  const options = {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    calendar: "persian",
  };
  const navigateTo = useNavigate();
  const myLocation = useLocation();
  /*** تاریخ امروز به فرمت فارسی ***/
  const todayDate = new Date().toLocaleDateString("fa-IR", options);
  const maxDate = numeric.p2e(todayDate);
  /*** وضعیت ها ***/
  const [valuationDate, setValuationDate] = useState(
    myLocation?.state?.mode !== "edit"
      ? numeric.p2e(todayDate)
      : myLocation?.state?.id
  );
  const [initialData, setInitialData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [isLoad, setIsLoad] = useState(false);
  const [excelUpdateData, setExcelUpdateData] = useState(null);
  const [fetchTrigger, setFetchTrigger] = useState(0);

  // تابع دریافت داده‌های ارزیابی
  const fetchValuationData = () => {
    const getValuationRequest = _axios.get(prefixUrl() + `/cheeka/?request=valuationTable&date=${valuationDate}`)
      .then((res) => {
        let data = res.data.data;
        // اگر اطلاعات اکسل وجود داشته باشد، داده‌ها را آپدیت می‌کنیم
        if (excelUpdateData) {
          data = data.map(item => {
            const updatedRow = excelUpdateData.find(row => String(row["کد کالا"]) === String(item.id));
            if (updatedRow) {
              return { ...item, price: updatedRow["ارزش کالا"] };
            }
            return item;
          });
          // پاک کردن داده‌های اکسل پس از ادغام
          setExcelUpdateData(null);
        }
        setInitialData(data);
        setIsLoad(true);
      })
      .catch((error) => {
        console.log(error);
        setIsLoad(true);
      });

    toast.promise(getValuationRequest, {
      pending: "در حال دریافت اطلاعات",
      success: "اطلاعات با موفقیت دریافت شد",
      error: "دریافت اطلاعات با مشکل مواجه شد",
    });
  };

  useEffect(() => {
    fetchValuationData();
  }, [valuationDate, fetchTrigger]);

  // تغییر قیمت کالا
  const handlePriceChange = (id, newPrice) => {
    const cleanValue = newPrice.replace(/[^\d]/g, "");
    if (cleanValue.trim() === "") {
      const updatedData = initialData.map((item) =>
        item.id === id ? { ...item, price: "0" } : item
      );
      setInitialData(updatedData);
    } else {
      const numericValue = cleanValue.replace(/^0+(?!$)/, "");
      const updatedData = initialData.map((item) =>
        item.id === id ? { ...item, price: numericValue } : item
      );
      setInitialData(updatedData);
    }
  };

  // ارسال اطلاعات ارزیابی
  const submitValuation = () => {
    // بررسی اینکه هیچ کالایی ارزش صفر نداشته باشد
    const hasInvalidPrice = initialData.some(item => !item.price || item.price === "0");

    if (hasInvalidPrice) {
      toast.error("ارزش هیچ کالایی نباید صفر باشد!");
      return;
    }
    // بررسی اینکه آیا قبلاً برای این تاریخ ارزش گذاری شده است یا نه
    const hasSubmittedBefore = initialData.some(item => item.submitted_before === "1");

    const proceedWithSubmission = () => {
      let temp = initialData.map(v => ({
        date: valuationDate,
        id: v.id,
        title: v.title,
        price: v.price
      }));

      _axios.post(prefixUrl() + "/cheeka/?request=submitValuation", temp).then((res) => {
        if (res.data.status) {
          toast.success(res.data.message);
          fetchValuationData();
        }
      }).catch((error) => {
        console.log(error);
      });
    };

    if (hasSubmittedBefore) {
      Swal.fire({
        text: "ارزش گذاری در این تاریخ انجام شده است. آیا مطمئن هستید؟",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "ثبت",
        cancelButtonText: "انصراف",
      }).then((result) => {
        if (result.isConfirmed) {
          proceedWithSubmission();
        }
      });
    } else {
      proceedWithSubmission();
    }
  };

  // خروجی گرفتن داده‌ها به فرمت اکسل
  const exportToExcel = () => {
    if (!initialData || initialData.length === 0) {
      toast.error("داده‌ای برای خروجی گرفتن وجود ندارد!");
      return;
    }

    const formattedData = initialData.map(item => ({
      "کد کالا": item.id,
      "نام کالا": item.title,
      "ارزش کالا": item.price
    }));

    const worksheet = XLSX.utils.json_to_sheet(formattedData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "ارزش‌گذاری");

    XLSX.writeFile(workbook, "valuation_data.xlsx");
  };

  // ارسال داده‌های اکسل برای به‌روزرسانی
  const handleExcelSubmit = (entryDate, excelData) => {
    setValuationDate(entryDate);
    setExcelUpdateData(excelData);
    setFetchTrigger(prev => prev + 1);
  };

  try {
    return !isLoad ? (
      <Loader />
    ) : (
      <>
        <section className='product__valuation'>
          <div className='content__section'>
            <div className='top__section'>
              <div className='filter__section'>
                <DynaDatePicker
                  label={"تاریخ ارزش گذاری"}
                  name={"valuationDate"}
                  className={"solid-dyna-input"}
                  value={valuationDate}
                  maxDate={maxDate}
                  setDataFromComponent={(data) => setValuationDate(data.valuationDate)}
                  disabled={myLocation?.state?.mode === "edit"}
                />
              </div>
            </div>

            <div className='table__section'>
              <div className="table__box">
                <ul className="table__header">
                  <li className="table__row">
                    <div style={{ width: "15%" }} className="table__cell">کد کالا</div>
                    <div style={{ width: "55%" }} className="table__cell">نام کالا</div>
                    <div style={{ width: "30%" }} className="table__cell">ارزش کالا</div>
                  </li>
                </ul>
                <ul className='table__body'>
                  {initialData?.map((item, index) => (
                    <li className="table__row" key={index}>
                      <div style={{ width: "15%" }} className="table__cell">{item?.id}</div>
                      <div style={{ width: "55%" }} className="table__cell">{item?.title}</div>
                      <div style={{ width: "30%" }} className="table__cell price">
                        <input
                          type="text"
                          value={UtilsFunctions.addCommas(item?.price)}
                          onChange={(e) => handlePriceChange(item?.id, e.target.value)}
                          className="price-input"
                        />
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>

          <div className="bottom__section">
            <div className="excel__buttons">
              <button onClick={() => setShowModal(true)} className="import__excel">
                ورود از اکسل
              </button>
              <button onClick={exportToExcel} className="export__excel">خروجی اکسل</button>
            </div>
            <div className="action__buttons">
              <button onClick={() => navigateTo(-1)} className="cancel__button">انصراف</button>
              <button onClick={submitValuation} className="submit__button">ثبت</button>
            </div>
          </div>
        </section>
        {showModal &&
          <UploadExcelModal
            onClose={() => setShowModal(false)}
            onExcelSubmit={handleExcelSubmit}
            maxDate={maxDate}
            initialData={initialData}
          />
        }
      </>
    );
  } catch (e) {
    return <>{e.toString()}</>
  }
};

export default ProductValuation;
